import { Link } from "react-router-dom";

const footerLinks = {
  快速导航: [
    { label: "首页", href: "/" },
    { label: "Po文技巧", href: "/category/tips" },
    { label: "Po文排版", href: "/category/formatting" },
    { label: "Po文范例", href: "/category/examples" },
    { label: "最佳发布时机", href: "/category/timing" },
  ],
  更多资源: [
    { label: "互动率提升", href: "/category/engagement" },
    { label: "平台攻略", href: "/category/platforms" },
    { label: "关于我们", href: "/about" },
  ],
  联系方式: [] as { label: string; href: string }[],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link
              to="/"
              className="text-xl font-bold text-foreground-900"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Po文完全指南
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              最全面的中文Po文创作指南。从标题撰写、内容排版到发布策略，帮助每一位创作者让好内容被更多人看见。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors" aria-label="Threads">
                <i className="ri-threads-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{title}</h4>
              {title === "联系方式" ? (
                <div className="space-y-2 text-sm text-foreground-600">
                  <p>
                    <i className="ri-mail-line mr-2"></i>
                    <a href="mailto:hello@powen.guide" className="hover:text-primary-500 transition-colors">
                      hello@powen.guide
                    </a>
                  </p>
                  <p>
                    <i className="ri-map-pin-line mr-2"></i>
                    台湾台北市信义区
                  </p>
                  <p>
                    <i className="ri-phone-line mr-2"></i>
                    (02) 2722-0000
                  </p>
                </div>
              ) : (
                <ul className="space-y-2">
                  {links.map((link) => (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Po文完全指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}